'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './event.routes';

import EventController from './event.controller.js';
import EventRegisterController from './eventregister.controller.js';
import * as weather from '../../../components/weather/weather';

export default angular.module('everlaps.event', [uiRouter, 'ya-openweathermap'])
	.config(routing)
	/*.filter("ComposeNumInscriptions", function() 
	{
		return function(r)
		{
			var ret = "(" + r.confirmed.length;
			if (r.unconfirmed && r.unconfirmed.length > 0) ret += "+" + r.unconfirmed.length;
			return ret + ")";
		};
	})*/
	.controller('EventController', EventController)
	.controller('RegisterController', EventRegisterController)
	.name;
	


// WEBPACK FOOTER //
// ./client/app/frontend/event/index.js